import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  const firstExtraIndex = packageIncludes.findIndex(item => item.kind === 'extra');
  return <section id="pricing" className="py-20 px-4 bg-[#F3F6FC] relative" data-id="element-217" data-mp="1s7sl0hgc5sx2">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-218" data-mp="1x9rpxvrq4xw4">
        <div className="text-center mb-10" data-id="element-219" data-mp="227t5w7tush3d">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-[#0B1F4D] uppercase" data-id="element-220" data-mp="226i42djyxjew">
            Your Complete <span className="text-[#1236C0]" data-id="element-221" data-mp="2wa1m6jhvx01">Electrical Technology Instructor Atlas</span> Package
          </h2>
          <p className="text-slate-700/80 text-sm md:text-base" data-id="element-222" data-mp="7vwc487xuz55">
            Everything You Need to Plan, Explain, Demonstrate &amp; Assess Your Students More Effectively
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#DBE4F3] border-2 border-[#0B1F4D] rounded-3xl p-1 relative shadow-xl shadow-[#0B1F4D]/10" data-id="element-223" data-mp="1hnv8ojqkbv6o">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#F5C400] text-[#06122E] font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-224" data-mp="20fxue9i2a1ns">
            <Sparkles size={14} data-id="element-225" data-mp="1repy1wz3vawc" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-226" data-mp="k1xxl7eiis4r">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-227" data-mp="jzuxfujnbimb" />

            <p className="text-sm font-bold tracking-widest text-[#7A5C00] mb-3" data-id="element-228" data-mp="hfou9p2uvw6t">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-[#F3F6FC] border border-[#D2DCEC] rounded-xl p-4" data-id="element-229" data-mp="mg3153sq1039">
              <li className="text-xs font-bold tracking-widest text-[#7A5C00]" data-id="element-230" data-mp="ciolv7ijahcj">
                THE COMPLETE 6-IN-1 VISUAL ELECTRICAL TRAINING SYSTEM
              </li>
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-231" data-mp="3i8kq4p9jmau" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-[#7A5C00]" data-id="element-232" data-mp="3kzjgy0t3axg2">
                      PLUS 5 EXCLUSIVE BONUSES
                    </li>}
                  {itemIndex === firstExtraIndex && <li className="pt-2 border-t border-[#D2DCEC]" aria-hidden="true" data-id="element-233" data-mp="3bzwq28xzla19" />}
                  <li className={`flex items-start gap-2 text-sm ${item.kind === 'extra' ? 'font-bold uppercase tracking-wide text-[#0B1F4D]' : 'text-slate-700'}`} data-id="element-234" data-mp="3g1i0lnn1tc8a">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-[#1236C0] shrink-0 mt-0.5" data-id="element-235" data-mp="31cf4v9mdrgsr" /> : <Check size={16} className="text-[#1236C0] shrink-0 mt-0.5" data-id="element-236" data-mp="3g8xljad92sz9" />}
                    <span data-id="element-237" data-mp="3ba31y67gl0e3">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-238" data-mp="3p4dii09axo92">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-239" data-mp="3l05ts32ug8au">
                <span className="text-2xl md:text-3xl text-[#0B1F4D] font-semibold" data-id="element-240" data-mp="2v2lyalhti6q">YOUR PRICE:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#1236C0]" data-id="element-241" data-mp="3u1m4kbxkmcfl">
                  {PRICE_LABEL}
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-242" data-mp="lzo5b311pdjf">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-243" data-mp="vofvb5mjpnrp">
              <span className="flex items-center gap-1.5" data-id="element-244" data-mp="3v5nuttr1zsa3">
                <Lock size={12} className="text-[#1236C0]" data-id="element-245" data-mp="30tto2wvot7h" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-246" data-mp="7zwl2kjxr0wz">
                <Zap size={12} className="text-[#1236C0]" data-id="element-247" data-mp="7ybs2zd9rq18" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-248" data-mp="d0kns3hj1671">
                <Wallet size={12} className="text-[#1236C0]" data-id="element-249" data-mp="1jfl8fd13q1yb" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}